import React from "react"
import styled from "styled-components"

import { minWidth, when, eq } from "utils"

import Icon from "icons"
import CloudinaryImage from "components/cloudinary-image"

export const Wrapper = styled.div`
  position: fixed;
  z-index: 101;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: none;
  justify-content: center;
  align-items: center;

  ${minWidth.mobile`
    display: flex;
  `}
`

export const Background = styled.div`
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  pointer-events: none;
`

export const Container = styled.div`
  position: relative;
  z-index: 102;
  width: 136.1rem;
`

export const VideoImageWrapper = styled.div`
  position: relative;
  width: 47.5rem;
  height: 67.5rem;
  margin: 0 auto;
`

export const Video = styled.video`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export const VideoProgress = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 0.8rem;
  background-color: rgba(255, 255, 255, 0.4);
`

export const VideoProgressBar = styled.div`
  width: 0;
  height: 0.8rem;
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  transition: width 0.25s linear;
`

export const LargeImage = styled(CloudinaryImage)`
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 42rem;
  padding: 2rem;
  border-radius: 0.6rem;
  display: flex;
  align-items: center;
  background-color: #fff;
`

export const SmallImage = styled(CloudinaryImage)`
  width: 10rem;
  height: 10rem;
  flex: 1 0 auto;
`

export const Meta = styled.div`
  margin-left: 2rem;
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.496rem;
  color: #222;
`

export const Description = styled.p`
  margin: 0.7rem 0;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.184rem;
  color: #222;
`

export const BuyButton = styled.button`
  padding: 0.8rem;
  border-radius: 5rem;
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.62rem;
  letter-spacing: 0.1rem;
  text-align: center;
  color: #fff;
`

export const CloseIcon = styled(Icon)`
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  cursor: pointer;
`

const ArrowIcon = styled(Icon)`
  position: absolute;
  top: 0;
  right: 3.5rem;
  transform: translateY(-2.5rem) rotate(180deg);
  display: none;
  color: ${({ theme }) => theme.component?.text || theme.colors.text.primary};
  cursor: pointer;
  outline: none;

  ${when("disabled")`
    color: ${({ theme }) => (theme.component?.isDarkBackground ? "#aaa" : "rgba(34, 34, 34, 0.2)")};
    pointer-events: none;
  `}

  ${minWidth.hamburgerLarge`
    display: block;
  `}

  ${eq("direction", "right")`
    right: 0;
    transform: translateY(-2.5rem);
    transform-origin: center;
  `}

  ${when("ismodal")`
    top: 50%;
    left: 0;
    color: #fff;

    ${when("disabled")`
      color: #aaa;
    `}

    ${eq("direction", "right")`
      left: unset;
      right: 0;
    `}
  `}
`

export const Arrow = (props) => <ArrowIcon id="arrow-shop" width={24} height={25} {...props} />
